import React from 'react';
import { Line, defaults } from 'react-chartjs-2';
import numeral from 'numeral';

defaults.global.defaultFontStyle = 'bold';
defaults.global.defaultFontFamily = '"Varela Round", "Arial Rounded MT", "Arial", "sans-serif"';
defaults.global.defaultFontSize = 14;

const sf = num => numeral(num).format('0.0a');

function getChartdataFromAnalytics(trackedAsset) {
  const latest = trackedAsset.statistics.slice(-20);
  const latestViews = latest.map(s => {
    return {
      x: Date.parse(s.createdDate),
      y: s.viewCount,
    };
  });
  return latestViews;
}

const AnalyticsChart = ({ trackedAsset }) => {
  if (!trackedAsset || !trackedAsset.statistics) return null;
  const analyticsData = getChartdataFromAnalytics(trackedAsset);
  const data = {
    datasets: [{
      fill: false,
      fillColor: 'rgba(38,228,184,0.05)',
      backgroundColor: 'rgba(38,228,184,0.05)',
      borderColor: 'rgba(38,228,184,1)',
      pointBorderColor: 'rgba(38,228,184,1)',
      pointBackgroundColor: '#fff',
      pointHoverBackgroundColor: 'rgba(38,228,184,1)',
      pointHoverBorderColor: 'rgba(38,228,184,1)',
      label: trackedAsset.title,
      data: analyticsData,
    }]
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    tooltips: {
      mode: 'index',
      intersect: false,
    },
    title: {
      display: false,
      text: 'Total Viewing',
      padding: 10,
      fontSize: 18,
    },
    legend: {
      display: false,
    },
    elements: {
      line: {
        tension: 0,
      },
    },
    layout: {
      padding: 20,
      fullWidth: false,
    },
    hover: {
      mode: 'nearest',
      intersect: true,
    },
    scales: {
      xAxes: [
        {
          type: 'time',
          ticks: {
            maxRotation: 0,
            autoSkip: true,
            maxTicksLimit: 5,
            // callback: function(value) {
            //     return (new Date(value).getDate() % 5 == 0) ? value : null;
            // },
          },
          time: {
            displayFormats: {
              day: 'ddd DD MMM',
            },
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            callback: function(label, index, labels) {
              return sf(label);
            },
          },
          scaleLabel: {
            display: false,
          },
        },
      ],
    },
  };

  return (
    <div className="analytics-chart">
      <h4>Total Viewing</h4>
      <div className="chartsubtitle">
        <p className="small light">
          LAST 20 DAYS
        </p>
      </div>
      <Line data={data} options={chartOptions} />
    </div>
  );
};

export default AnalyticsChart;



/** WEBPACK FOOTER **
 ** ./src/components/chart/index.js
 **/